module.exports = "<div class=\"cases\">\r\n\r\n\t<ansyn-cases-tools></ansyn-cases-tools>\r\n\t<ansyn-cases-table></ansyn-cases-table>\r\n\t<ansyn-cases-modal-container></ansyn-cases-modal-container>\r\n\r\n</div>\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/cases/components/cases/cases.component.html
// module id = ../../../../../src/app/packages/menu-items/cases/components/cases/cases.component.html
// module chunks = main